import React, { Component } from 'react';
import './Steps.css';
import Tooltip from './Tooltip';
import API from '../services/api';
import Slim from './slim/slim.react';

class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepNumber: 2,
      fields: {
        name: '',
        password: '',
        password2: '',
        photo: '',
        originalPhoto: '',
      },
      errors: {
        username: '',
        password2: '',
      },
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => (
      this.state.fields[field].length === 0
    ));
    return emptyFields.length === 0 && (this.state.fields.password === this.state.fields.password2);
  }

  handleFieldChange(e, name) {
    let { errors, fields } = this.state;
    fields[name] = e.target.value;

    if(name === 'name') {
      errors.username = '';
      if(e.target.value.includes('@') || e.target.value.includes(' ')) {
        errors.username = 'Username cannot contain "@" or whitespaces';
      }

      if(e.target.value.length > 25) {
        errors.username = 'Username cannot be longer than 25 characters';
      }
    }
    if(name === 'password2' && fields.password !== fields.password2) {
      errors.password2 = 'Passwords must be the same.';
    }else {
      errors.password2 = '';
    }
    this.setState({ fields, errors });
  }

  handleUpload(file){
    this.getBase64(file);
    return true;
  }

  getBase64(file) {
    const reader = new FileReader();
    let component = this;
    let { fields } = this.state;

    reader.readAsDataURL(file);
    reader.onload = () => {
      fields.originalPhoto = reader.result;
      component.setState({
        fields,
      });
    };
    reader.onerror = (error) => {
      console.log('Error: ', error);
    };
  }

  handleBase64(formdata, progress, success, failure, slim) {
    let fields = this.state.fields;
    fields.photo = slim.dataBase64.output.image;
    this.setState({ fields }, () => {success("upload done");});
  }


  handleNext(e) {
    e.preventDefault();
    (new API()).get('/users/validate-field', {field: 'name', value: this.state.fields.name})
      .then(response => {
        if(response.valid) {
          this.props.saveData(this.state.fields);
          this.props.proceed(this.state.stepNumber);
        } else {
          this.setState({
            errors: {
              username: 'Username is already in use. Choose different one.'
            }
          });
        }
      })
  }

  render() {
    const { errors } = this.state;
    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          Let's go
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number done">2</li>
          <li className="step-number">3</li>
          <li className="step-number">4</li>
          <li className="step-number">5</li>
          <li className="step-number">6</li>
        </ul>
        <div className="field-container text open">
          <div className="field-title">Username:<Tooltip icon="?"><p>Choose it wisely you cannot change it afterwards. You can use the following: _ - . in your username.</p></Tooltip></div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="name" placeholder="Don't use your real name..." />
              {errors.username && errors.username.length > 0 && <span className="error">{errors.username}</span>}
            </div>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">Password:</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="password" name="password" placeholder="Your password..." />
            </div>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">Confirm password:</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="password" name="password2" placeholder="Confirm password..." />
              {errors.password2 && errors.password2.length > 0 && <span className="error">{errors.password2}</span>}
            </div>
          </div>
        </div>
        <div className="field-container image open">
          <div className="field-title">Upload a photo:<Tooltip icon="?"><p>Upload an image of your face, no nudity please.</p></Tooltip></div>
          <div className="row">
            <div className="col">
              <Slim ratio="1:1"
                    minSize={ { width:600, height:600 } }
                    uploadBase64="true"
                    jpegCompression={70}
                    instantEdit="true"
                    didLoad={this.handleUpload.bind(this)}
                    push="true"
                    post={['input', 'output', 'actions']}
                    label="Drop your image here, or click to upload one."
                    service={ this.handleBase64.bind(this) }
              >
                <input type="file" name="photo"/>
              </Slim>
            </div>
          </div>
        </div>
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            onClick={(e) => {e.preventDefault();this.props.back(this.state.stepNumber);}}
          >
            Back
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step2;


// WEBPACK FOOTER //
// ./src/components/Step2.js